import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import './SearchBar.css'

import Button from '../Button/Button'
import Dropdown from '../DropDown/Dropdown'
import Icon from '../Icon2/Icon'
import TextInput from '../TextInput/TextInput'
import { SearchSuggestion } from './SearchSuggestion'
import RenderValueField from '../AdvanceSearchV2/RenderFields/RenderValueFields'

export type SearchBarProps = {
  testId?: string
  withDropdown?: boolean
  dropdownList?: any
  recentSearches: any
  handleSearchSubmit: Function
  handleRecentSearchClear: Function
  handleSearchClear: Function
  onSearchOpen?: Function
  searchConfig: any
  inputText: string
  isAdvanceQuery?: any
  searchIn?: string
  /*props used for custom fields */
  customFieldData?: any
  fetchData?: any
  setCustomFieldsData?: any
  variation?: string
  loading?: boolean
}

const InputSuffix = ({ handleSearchClear }) => {
  return (
    <Icon
      version="v2"
      icon="Cancel"
      size="small"
      className="SearchBar__input--cancel"
      onClick={handleSearchClear}
      testId="cs-search-bar-cancel"
    />
  )
}

const SearchBar = (props: SearchBarProps) => {

  const {
    testId = "cs-search-bar",
    withDropdown = true,
    dropdownList,
    searchConfig,
    recentSearches = [],
    inputText = '',
    isAdvanceQuery = false,
    searchIn,
    customFieldData,
    setCustomFieldsData,
    fetchData,
    variation,
    loading
  } = props
  const { searchPlaceholder = "Search text", historyInfo } = searchConfig

  const [inputDropdown, setInputDropdown] = useState(false)

  const [searchValue, setSearchValue] = useState(inputText || '')

  const [isCursorInside, setIsCursorInside] = useState(false)
  const [isCursorInsideForField, setIsCursorInsideForField] = useState(false)

  const [recentSearchArr, setRecentSearches] = useState(recentSearches)
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState('-1')

  const handleOutsideClick = () => {
    try {
      if (!isCursorInside) {
        setInputDropdown(false)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleOutsideClickForField = () => {
    try {
      if (!isCursorInsideForField) {
        closeAutoComplete()
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick)
    return () => {
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [isCursorInside])

  useEffect(() => {
    document.addEventListener('click', handleOutsideClickForField)
    return () => {
      document.removeEventListener('click', handleOutsideClickForField)
    }
  }, [isCursorInsideForField])


  useEffect(() => {
    setSearchValue(inputText)
  }, [inputText])

  useEffect(() => {
    console.log('change', recentSearches)
    setRecentSearches(recentSearches)
  }, [recentSearches.map((item, index) => `${item.primary}${index}`).join('')])

  const onChangeTextInput = (e) => {
    setSearchValue(e.target?.value)
  }

  const handleInputClick = () => {
    if (!inputDropdown) {
      setInputDropdown(true)
      props.onSearchOpen && props.onSearchOpen({ isInputDropdownOpen: true })
    } else {
      setInputDropdown(false)
      props.onSearchOpen && props.onSearchOpen({ isInputDropdownOpen: false })
    }
  }

  const handleSearchClick = async (recentSearch: any = '', customFieldDataArgs = '') => {
    try {
      if (recentSearch) {
        setSearchValue(recentSearch.primary)
      }
      setInputDropdown(false)
      await props.handleSearchSubmit({
        searchValue: recentSearch ? recentSearch?.primary || searchValue || '' : searchValue,
        recentSearch,
        customFieldData: customFieldDataArgs
      })
    } catch (error) {
      console.log('🚀 ~ handleSearchClick ~ error:', error)
    }
  }

  const handleRecentSearchClear = (event, recentSearchArg) => {
    props.handleRecentSearchClear(event, recentSearchArg)
  }

  const handleSearchClear = () => {
    setSearchValue('')
    props.handleSearchClear && props.handleSearchClear()
  }

  const handleKeyUp = (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault()
      handleSearchClick()
    }
  }

  const closeAutoComplete = () => {
    if (activeSuggestionIndex !== '-1') {
      setTimeout(() => {
        setActiveSuggestionIndex('-1')
      })
    }
  }

  const suggestionIndex = '0-0-0-value'
  const openAutoComplete = (e) => {
    e.stopPropagation()
    if (activeSuggestionIndex !== suggestionIndex) {
      props.onSearchOpen && props.onSearchOpen({ isInputDropdownOpen: true })
      setActiveSuggestionIndex(suggestionIndex)
    }
  }

  const updateAdvancedQueryArray = (argsData) => {
    console.log('🚀 ~ updateAdvancedQueryArray ~ argsData:', argsData)
    const { currentQuery } = argsData
    const { value = [] } = currentQuery || {}
    customFieldData.value = value
    setCustomFieldsData({ ...customFieldData })
  }

  const classNames = cn('SearchBar flex', {
    'SearchBar--with-dropdown': withDropdown,
    'SearchBar--with-advQuery': isAdvanceQuery
  })
  const propsData = {
    // activeSuggestionIndex: '
    // 0-0-0-value', toggle this to -1 to close dropdown
    activeSuggestionIndex,
    query: customFieldData,
    queryObj: {
      cursorY: 0
    },
    queryIndex: 0,
    queryObjIndex: 0,
    queryArray: [customFieldData],
    selectedModule: 'entries',
    parentQueryObject: {},
    fetchData,
    withPortal: false
  }

  const onKeyDownSpecificFieldValue = (e) => {
    const { key } = e

    if (key === 'Enter') {
      handleSearchClick('', customFieldData)
    }
  }


  if (searchIn === 'specificFields') {
    const allNonTextTypeFields = ['selectLabel', 'booleanLabel', 'dateLabel', 'fileLabel', 'linkLabel', 'referenceLabel']
    const isTextTypeField = customFieldData.queryType && !allNonTextTypeFields.includes(customFieldData.queryType)
    return (
      <div className="searchBar__customField">
        <Dropdown
          className="SearchBar__select"
          testId="cs-search-bar-select"
          closeAfterSelect={true}
          list={dropdownList}
          type="select"
          withArrow={true}
          version="v2"
          viewAs="value"
          isDisabled={isAdvanceQuery}
        />
        <div
          className="field-wrapper__value"
          onClick={openAutoComplete}
          onKeyDown={onKeyDownSpecificFieldValue}
          onMouseEnter={() => {
            setIsCursorInsideForField(true)
          }}
          onMouseLeave={() => {
            setIsCursorInsideForField(false)
          }}
        >
          <RenderValueField
            {...propsData}
            openAutoComplete={openAutoComplete}
            closeAutoComplete={closeAutoComplete}
            updateAdvancedQueryArray={updateAdvancedQueryArray}
          />
          {isTextTypeField && activeSuggestionIndex === suggestionIndex && recentSearchArr.length > 0 && !isAdvanceQuery && (
            <SearchSuggestion
              recentSearchArr={recentSearchArr}
              onRecentSearchClick={handleSearchClick}
              handleRecentSearchClear={handleRecentSearchClear}
              historyInfo={historyInfo}
              loading={loading}
            />
          )}
        </div>

        <Button
          icon="v2-Search"
          className="SearchBar__button ml-4"
          testId="cs-search-bar-input-submit"
          onClick={() => handleSearchClick('', customFieldData)}
          version="v2"
          disabled={isAdvanceQuery}>
          Search
        </Button>
      </div>
    )
  }

  return (
    <div className={`${classNames}`} data-test-id={testId}>
      {withDropdown && (
        <Dropdown
          className="SearchBar__select"
          testId="cs-search-bar-select"
          closeAfterSelect={true}
          list={dropdownList}
          type="select"
          withArrow={true}
          version="v2"
          viewAs="value"
          isDisabled={isAdvanceQuery}
        />
      )}

      <div
        className="SearchBar__input"
        onMouseEnter={() => {
          setIsCursorInside(true)
        }}
        onMouseLeave={() => {
          setIsCursorInside(false)
        }}>
        <TextInput
          autoFocus={variation === 'headerSearch'}
          version="v2"
          placeholder={searchPlaceholder}
          testId="cs-search-bar-input"
          name="search"
          type="text"
          value={isAdvanceQuery ? 'Advanced search query applied' : searchValue}
          onChange={!isAdvanceQuery && onChangeTextInput}
          // onClick={handleInputClick}
          onFocus={handleInputClick}
          // onBlur={handleInputClick}
          suffix={(searchValue || isAdvanceQuery) && <InputSuffix handleSearchClear={handleSearchClear} />}
          onKeyUp={handleKeyUp}
        />

        {inputDropdown && !isAdvanceQuery && (
          <SearchSuggestion
            recentSearchArr={recentSearchArr}
            onRecentSearchClick={handleSearchClick}
            handleRecentSearchClear={handleRecentSearchClear}
            historyInfo={historyInfo}
            loading={loading}
          />
        )}
      </div>
      {variation === 'headerSearch' ? (
        <Button
          icon="v2-Search"
          className="SearchBar__button headerSearch__button"
          testId="cs-search-bar-input-submit"
          onClick={() => handleSearchClick()}
          version="v2"
          disabled={isAdvanceQuery}
          buttonType="tertiary-outline"
        />
      ) : (
        <Button
          icon="v2-Search"
          className="SearchBar__button ml-4"
          testId="cs-search-bar-input-submit"
          onClick={() => handleSearchClick()}
          version="v2"
          disabled={isAdvanceQuery}>
          Search
        </Button>
      )}


    </div>
  )
}

export default SearchBar
